import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3ed4355a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed4355a')) {
      api.createRecord('3ed4355a', component.options)
    } else {
      api.reload('3ed4355a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=3ed4355a", function () {
      api.rerender('3ed4355a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/tax_return/Index.vue"
export default component.exports